import { envTypes } from './envTypes';
import { actionLogMessageType } from './actionLogMessageType';
import { activityType } from './activityType';
import { viewerType } from './viewerType';
import { reportType } from './reportType';
import { deploymentType } from './deploymentType';
import { emitedEventsTypes } from './emitedEventsTypes';
import { envActions } from './envActions';
import { userPermissions } from './userPermissions';
import { FilterOption } from './filterOption';
import { actionType } from './actionType';
import { PackageType } from './packageType';
import { testThemeStatuses } from './testThemeStatuses';
import { excludeType } from '@src/constants/excludeType';

const activeTouchScreenMenuClass = 'activeTouchScreenMenuItem';
const activeMenuClass = 'activeMenuItem';

export const consts: Readonly<any> = {
    envTypes,
    actionLogMessageType,
    activityType,
    viewerType,
    reportType,
    deploymentType,
    activeMenuClass,
    activeTouchScreenMenuClass,
    emitedEventsTypes,
    envActions,
    userPermissions,
    FilterOption,
    actionType,
    PackageType,
    testThemeStatuses,
    excludeType

};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/consts.ts